const SENTRY_IGNORED_AUTH_MARKERS = ['interaction_in_progress', 'user_cancelled'];

const toText = (value: unknown): string => {
  if (typeof value === 'string') {
    return value;
  }

  if (value == null) {
    return '';
  }

  try {
    return JSON.stringify(value);
  } catch {
    return '';
  }
};

const includesIgnoredMarker = (...values: unknown[]): boolean => {
  const text = values.map(toText).join(' ').toLowerCase();
  return SENTRY_IGNORED_AUTH_MARKERS.some((marker) => text.includes(marker));
};

const errorFields = (error: unknown): unknown[] => {
  const source = error as Record<string, unknown> | undefined;
  const response = source?.response as Record<string, unknown> | undefined;

  return [
    error,
    source?.name,
    source?.type,
    source?.message,
    source?.value,
    source?.error,
    source?.code,
    source?.errorCode,
    source?.subError,
    source?.error_description,
    source?.errorMessage,
    source?.description,
    response?.data,
  ];
};

export const shouldIgnoreSentryError = (error: unknown): boolean => {
  return includesIgnoredMarker(...errorFields(error));
};

export const shouldIgnoreSentryEvent = (
  event: {
    message?: unknown;
    exception?: { values?: Array<{ type?: unknown; value?: unknown }> };
  },
  hint?: { originalException?: unknown },
): boolean => {
  const exceptionValues = event.exception?.values ?? [];
  const eventFields: unknown[] = [event.message];

  for (const exceptionValue of exceptionValues) {
    eventFields.push(exceptionValue.type, exceptionValue.value);
  }

  return includesIgnoredMarker(...eventFields) || shouldIgnoreSentryError(hint?.originalException);
};
